import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Хранит активную вкладку в URL (?tab= или произвольный param) вместо useState.
 * Drop-in замена для `const [tab, setTab] = useState('all')`.
 *
 * Смена вкладки сбрасывает пагинацию (удаляет ?page=) в одном атомарном апдейте,
 * чтобы не остаться на 5-й странице нового списка. Прочие query-параметры (поиск)
 * сохраняются. На дефолтной вкладке параметр из URL убирается — ссылка чистая.
 */
export const useTabParam = (defaultTab: string, param = 'tab'): readonly [string, (tab: string) => void] => {
	const [searchParams, setSearchParams] = useSearchParams()
	const tab = searchParams.get(param) ?? defaultTab

	const setTab = useCallback(
		(next: string) => {
			setSearchParams(prev => {
				if (next === defaultTab) {
					prev.delete(param)
				} else {
					prev.set(param, next)
				}
				prev.delete('page')
				return prev
			})
		},
		[setSearchParams, defaultTab, param]
	)

	return [tab, setTab] as const
}
